import { useEffect, useState } from 'react';
import i18n from '../services/i18n/i18n';

const useI18nReady = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (i18n.isInitialized) {
      setIsReady(true);
      return;
    }
    const handleInit = () => setIsReady(true);
    i18n.on('initialized', handleInit);
    // eslint-disable-next-line consistent-return
    return () => { i18n.off('initialized', handleInit); };
  }, []);

  return isReady;
};

export default useI18nReady;
